import { DDSToast } from "@web-monorepo/dds";
import { Trans } from "@web-monorepo/i18n/macro";
import css from "./TranslationsLoading.module.css";

/**
 * Over the page while it shows in English, waiting for a slow catalog: see `LocaleGate`. Its string
 * is in the `i18n` namespace (see `I18N_FILES` in packages/i18n/src/namespaces.ts), so it is
 * translated while the catalog loads.
 */
export function TranslationsLoading() {
  return (
    <div className={css.pending}>
      {/* On the text, not around the toast: the toast is an `<aside>`, a landmark of its own. */}
      <DDSToast variant="neutral">
        <span role="status">
          <Trans>Loading translations…</Trans>
        </span>
      </DDSToast>
    </div>
  );
}
